module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block",
    class: {
      'hover': _vm.hovering
    },
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [_vm._t("source"), _vm._v(" "), _c('div', {
    ref: "meta",
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "go",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goJsfiddle
    }
  }, [_vm._v("Try in Jsfiddle!")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight",
    domProps: {
      "innerHTML": _vm._s(_vm.codePrismed)
    }
  })]), _vm._v(" "), _c('div', {
    ref: "control",
    staticClass: "demo-block-control",
    class: {
      'is-fixed': _vm.fixedControl
    },
    on: {
      "click": function($event) {
        _vm.isExpanded = !_vm.isExpanded
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "arrow-slide"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "text-slide"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.controlText))])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6b0289d4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/demo-block.vue
// module id = 68
// module chunks = 0